module.exports = __webpack_public_path__ + "./assets/icons/talent1.png";